import { createFromIconfontCN } from '@ant-design/icons';

export default createFromIconfontCN({
    scriptUrl: "/iconfont/font_4749113_xy1yc476oxn.js"
})